import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { Post } from "./Post";
import { blogPosts } from "./blogData";
import "./Blog.css";
const Blog = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/"
              mode="ios"
              text=""
              className="transparent-back-button"
            />
          </IonButtons>
          {/* <IonTitle style={{ padding: "10px" }} className="poetsen"> */}
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              padding: "7px",
            }}
            className="poetsen"
          >
            <img
              src="/logo4.png"
              alt="LoonLog Logo"
              style={{ height: "30px" }} // Adjust height and margin as needed
            />
            LoonLog
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen style={{ padding: "10px" }}>
        {/* <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large" className="poetsen">
              <div
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <img
                  src="/logo4.png"
                  alt="LoonLog Logo"
                  style={{
                    height: "40px",
                    paddingLeft: "12px",
                  }} // Adjust height and margin as needed
                />
                LoonLog
              </div>
            </IonTitle>
          </IonToolbar>
        </IonHeader> */}

        {blogPosts.map((post, index) => (
          <Post post={post} key={`post_${index}`} />
        ))}
      </IonContent>
    </IonPage>
  );
};

export default Blog;
